import ErrorView from 'components/ErrorView';
import useCommon from 'hooks/useCommon';
import { capitalize } from 'libs/utils';
import React, { FunctionComponent } from 'react';
import useNavigator from 'hooks/useNavigator';

const NotFound: FunctionComponent = () => {
  const { title } = useCommon();
  const { navigateCallback } = useNavigator();

  return (
    <ErrorView
      title="Your email is successfully verified. Thank you!"
      message="You can return to website!"
      actionTitle={capitalize(title)}
      onClick={navigateCallback('/')}
    />
  );
};

export default NotFound;
